"use strict";
import { useMemo } from "react";
export function useTokenBalances(_options = {}) {
  return useMemo(() => {
    return {
      balanceMap: {},
      balanceList: [],
      loading: false
    };
  }, []);
}
